import React, { useEffect, useState, useRef } from 'react';
import { ClipboardOutline, MailOutline, CloseSharp } from 'react-ionicons';
import './css/style.css';
import cbImages from './images/'; // 디렉토리에서 모든 이미지 가져오기
import demoMap from './images/demo_map.png';
import wiMockupContact from './images/wisight_mockup_contact.png';


export default function JSoftLab() {
  // Demo Click Event
  const checkList = [
    { title: 'Building', titleSub: '건물형', content: '건물 기반의 대시보드', classname: 'build-wrap', link: 'https://multi.devj.app/index_build.html',img: cbImages.demo_map01 },
    { title: 'Map', titleSub: '지도형', content: '지도 기반의 대시보드', classname: 'map-wrap', link: 'https://multi.devj.app/index_map.html' , img: cbImages.demo_map02},
    { title: 'Multi', titleSub: '멀티형', content: '통합형 대시보드', classname: 'multi-wrap', link: 'https://multi.devj.app/index_multi.html', img:cbImages.demo_map03},
    { title: 'Network', titleSub: '네트워크형', content: '네트워크 전용 대시보드', classname: 'network-wrap', img: cbImages.demo_map04},
  ];
  const modalDatas = [
    {idx: 1, title: "수원시청", gubun: "Wireless NMS ( 맞춤형 )", img: cbImages.site_image_001, significant: "수원시 공공, 직원용 무선 관제 시스템, 권역별 대시보드 지원"},
    {idx: 2, title: "경복대학교", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_002, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 3, title: "김포시청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_003, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 4, title: "울산문수축구경기장", gubun: "Network NMS ( 맞춤형 )",img: cbImages.site_image_004, significant: "경기장 프레스석 스위치 관제 시스템, 포트별 상태 및 전송량 모니터링"},
    {idx: 5, title: "한국외식업중앙회", gubun: "IPT NMS ( 지도형 )", img: cbImages.site_image_005, significant: "전국 300여개 지부, 지회 IPT 상태 체크 및 통화 정보 모니터링"},
    {idx: 6, title: "양주시청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_006,significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 7, title: "부천시청", gubun: "IPT NMS ( 건물형 )", img: cbImages.site_image_007,significant: "부천시 공공기관 내 IPT 및 부가장비의 상태 및 통화 정보 모니터링 시스템"},
    {idx: 8, title: "경기북부교육청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_008, significant: "교육청 내 IPT 상태 및 통화정보를 층별로 관제, 렉 부가장비 모니터링"},
    {idx: 9, title: "양구군청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_009, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 10, title: "의정부시청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_010, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 11, title: "과천시청", gubun: "Wireless NMS ( 멀티형 )", img: cbImages.site_image_011, significant: "직원용 무선 관제 시스템, 지도상 건물로 표시, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 12, title: "안양시청", gubun: "Wireless NMS ( 맞춤형 )", img: cbImages.site_image_012, significant: "LTE, 공공, 직원용 무선 통합관제 시스템, 지도상 건물로 표시, AP 상태 및 접속정보, 전송량 모니터링, 단독지도형 지원"},
    {idx: 13, title: "전북도청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_013, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 14, title: "헤이그라운드", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_014, significant: "건물내 무선 관제 시스템, AP 정보 및 스위치별 포트 정보 모니터링"},
    {idx: 15, title: "안산시청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_015, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 16, title: "춘천시청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_016, significant: "공공, 직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 17, title: "전남도청", gubun: "Wireless NMS ( 건물형 )", img: cbImages.site_image_017, significant: "직원용 무선 관제 시스템, AP 상태 및 접속정보, 전송량 모니터링"},
    {idx: 18, title: "대구시청", gubun: "Network NMS ( 맞춤형 )", img: cbImages.site_image_018, significant: "대구시 시청관사내 스위치 관제 시스템, 포트별 상태 및 전송량 모니터링"}
  ]

  const [btnActive, setBtnActive] = useState(1);

  const toggleActive = (idx) => {
    setBtnActive(idx);
  };

  // Usecase Default Event
  const [checkActive, setCheckActive] = useState(true);

  const handleOver = () => {
    setCheckActive(false);
  };

  // Line Motion
  useEffect(() => {
    function calcDashoffset(scrollY, element, length) {
      const ratio = (scrollY - element.offsetTop) / element.offsetHeight;
      return Math.min(Math.max(length - length * ratio, 0), length);
    }
  
    function handleLineMotion(content, paths) {
      paths.forEach((path) => {
        const pathLength = path.getTotalLength();
        path.style.strokeDasharray = `${pathLength} ${pathLength}`;
        path.style.strokeDashoffset = calcDashoffset(
          window.scrollY + window.innerHeight * 0.6,
          content,
          pathLength
        );
      });
    }
  
    function handleScroll() {
      const content1 = document.querySelector('.linegroup1');
      const content2 = document.querySelector('.features');
      const content3 = document.querySelector('.services');
      const content4 = document.querySelector('.usecase');
      const content5 = document.querySelector('.contactus');
      const content6 = document.querySelector('.jnms-info');
      const paths = [
        ['.path11', '.path12', '.path13', '.path14', '.path15', '.path16'],
        ['.path21', '.path22', '.path23', '.path24', '.path25', '.path26'],
        ['.path31', '.path32', '.path33', '.path34', '.path35', '.path36'],
        ['.path41', '.path42', '.path43', '.path44', '.path45', '.path46', '.path47', '.path48', '.path49', '.path40'],
        ['.path51', '.path52', '.path53', '.path54', '.path55'],
        ['.pathJnms']
      ].map((pathSelectors) => pathSelectors.map((selector) => document.querySelector(selector)));
  
      handleLineMotion(content1, paths[0]);
      handleLineMotion(content2, paths[1]);
      handleLineMotion(content3, paths[2]);
      handleLineMotion(content4, paths[3]);
      handleLineMotion(content5, paths[4]);
      handleLineMotion(content6, paths[5]);
    }
  
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 스크롤 다운 사라지는 스크립트
  const [scrollClass, setScrollClass] = useState('');

  const handleScroll = () => {
    if (window.scrollY >= 160) {
      setScrollClass('action');
    } else {
      setScrollClass('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 클립보드 복사
  const textRef1 = useRef(null);
  const textRef2 = useRef(null);

  function copyClipboard(ref, message) {
    const text = ref.current.textContent;
    const textarea = document.createElement('textarea');
    textarea.textContent = text;
    document.body.append(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();

    // 복사 후 팝업 메시지 표시
    window.alert(message);
  }

  // 모달 구현
  const [modalClose,setModalClose] = useState('none');
  const [modalCheck,setModalCheck] = useState(0)
  const handleModal = (idx) => {
    setModalCheck(idx);
    setModalClose('flex');
  }

  const handleEsc = () => {
    setModalClose('none')
  }

  return (
    <div className='jsl-wrap'>
      <div className='line-set'>
        <img src={cbImages.diAp} className='diAp'></img>
        <img src={cbImages.diBuild} className='diBuild'></img>
        <img src={cbImages.diIpp} className='diIpp'></img>
        <img src={cbImages.diMobile} className='diMobile'></img>
        <img src={cbImages.diServer} className='diServer'></img>
        <img src={cbImages.diSwitchpoe} className='diSwitchpoe'></img>

        <div className='step1'>
          <svg className='line01'>
            <circle cx="110" cy="105" r="2" fill="#616161" />
            <path className='path11' d="M110 105 L110 688 Q110 696, 107 696 T104 704 L104 1304 Q104 1312, 110 1312 L612 1312 Q620 1312, 620 1320 L620 1940 Q620 1948, 612 1948 L148 1948 Q140 1948, 140 1956 L140 2400" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line02'>
            <circle cx="282" cy="303" r="2" fill="#616161" />
            <path className='path12' d="M282 303 L282 696 Q282 704, 274 704 L120 704 Q112 704, 112 712 L112 1304 Q112 1320, 120 1320 L620 1320 Q628 1320, 628 1328 L628 1932 Q628 1940, 620 1940 L156 1940 Q148 1940, 148 1948 L148 2400" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line03'>
            <circle cx="690" cy="536" r="2" fill="#616161" />
            <path className='path13' d="M690 536 L690 696 Q690 704, 698 704 L1156 704 Q1164 704, 1164 712 L1164 1328 Q1164 1336, 1156 1336 L644 1336 Q636 1336, 636 1344 L636 1924 Q636 1932, 628 1932 L164 1932 Q156 1932, 156 1940 L156 2400" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line04'>
            <circle cx="934" cy="208" r="2" fill="#616161" />
            <path className='path14' d="M934 208 L934 688 Q934 696, 942 696 L1164 696 Q1172 696, 1172 704 L1172 1320 Q1172 1328, 1164 1328 L652 1328 Q644 1328, 644 1336 L644 1916 Q644 1924, 636 1924 L172 1924 Q164 1924, 164 1932 L164 2400" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line05'>
            <circle cx="1096" cy="397" r="2" fill="#616161" />
            <path className='path15' d="M1096 397 L1096 680 Q1096 688, 1114 688 L1172 688 Q1180 688, 1180 696 L1180 1312 Q1180 1320, 1172 1320 L660 1320 Q652 1320, 652 1328 L652 1908 Q652 1916, 644 1916 L180 1916 Q172 1916, 172 1924 L172 2400" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line06'>
            <circle cx="1258" cy="208" r="2" fill="#616161" />
            <path className='path16' d="M1258 208 L1258 696 Q1258 704, 1250 704 L1196 704 Q1188 704, 1188 712 L1188 1304 Q1188 1312, 1172 1312 L668 1312 Q660 1312, 660 1320 L660 1900 Q660 1908, 652 1908 L188 1908 Q180 1908, 180 1916 L180 2400" strokeWidth="1" fill="none" />
          </svg>
        </div>

        <div className='step2'>
          <svg className='line01'>
            <path className='path21' d="
              M140 0
              L140 960 
            " strokeWidth="1" fill="none" />
          </svg>
          <svg className='line02'>
            <path className='path22' d="
              M148 0
              L148 960 
            " strokeWidth="1" fill="none" />
          </svg>
          <svg className='line03'>
            <path className='path23' d="
              M156 0
              L156 960 
            " strokeWidth="1" fill="none" />
          </svg>
          <svg className='line04'>
            <path className='path24' d="
              M164 0
              L164 672 
              Q164 680, 172 680
              L1600 680
            " strokeWidth="1" fill="none" />
            <circle cx="1278" cy="680" r="2" fill="#6757A7" />
          </svg>
          <svg className='line05'>
            <path className='path25' d="
              M172 0
              L172 432 
              Q172 440, 180 440
              L1600 440
            " strokeWidth="1" fill="none" />
            <circle cx="1278" cy="440" r="2" fill="#FFAC00" />
          </svg>
          <svg className='line06'>
            <path className='path26' d="
              M180 0
              L180 192
              Q180 200, 188 200
              L1600 200
            " strokeWidth="1" fill="none" />
            <circle cx="1278" cy="200" r="2" fill="#818181" />
          </svg>
        </div>

        <div className='step3'>
          <svg className='line01'>
            <defs>
              <linearGradient id="grad1" x2="0%" y2="100%">
                <stop offset="60%" stopColor="#414141" />
                <stop offset="100%" stopColor="#1C1D1E" />
              </linearGradient>
            </defs>
            <path className='path31' d="
              M140 0
              L140 136
              Q140 144, 132 144
              L8 144
              Q0.5 144, 0.5 152
              L0.5 360
              Q0.5 368 8 368
              L312 368
              Q320 368, 320 376
              L320 584
              Q320 592, 312 592
              L8 592
              Q0.5 592, 0.5 600
              L0.5 816
            " stroke="url(#grad1)" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line02'>
            <defs>
              <linearGradient id="grad2" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#56B78F" />
                <stop offset="100%" stopColor="#313131" />
              </linearGradient>
            </defs>
            <path className='path32' d="
              M148 0
              L148 128
              Q148 136, 156 136
              L312 136
              Q320 136, 320 144
              L320 360
              Q320 368, 328 368
              L632 368
              Q640 368, 640 376
              L640 584
              Q640 592, 632 592
              L328 592
              Q320 592, 320 600
              L320 808
              Q320 816, 312 816
              L8 816
              Q0.5 816, 0.5 824
              L0.5 960
            " stroke="url(#grad2)" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line03'>
            <defs>
              <linearGradient id="grad3" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#176DC3" />
                <stop offset="100%" stopColor="#313131" />
              </linearGradient>
            </defs>
            <path className='path33' d="
              M156 0
              L156 136
              Q156 144, 164 144
              L632 144
              Q640 144, 640 152
              L640 360
              Q640 368, 648 368
              L952 368
              Q960 368, 960 376
              L960 584
              Q960 592, 952 592
              L648 592
              Q640 592, 640 600
              L640 808
              Q640 816, 632 816
              L328 816
              Q320 816, 320 824
              L320 960
            " stroke="url(#grad3)" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line04'>
            <defs>
              <linearGradient id="grad4" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#6757A7" />
                <stop offset="100%" stopColor="#313131" />
              </linearGradient>
            </defs>
            <path className='path34' d="M1132 0 L1132 584 Q1132 592, 1124 592 L968 592 Q960 592, 960 600 L960 808 Q960 816, 952 816 L648 816 Q640 816, 640 824 L640 960" stroke="url(#grad4)" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line05'>
            <defs>
              <linearGradient id="grad5" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#FFAC00" />
                <stop offset="100%" stopColor="#313131" />
              </linearGradient>
            </defs>
            <path className='path35' d="M1140 0 L1140 808 Q1140 816, 1132 816 L968 816 Q960 816, 960 824 L960 960" stroke="url(#grad5)" strokeWidth="1" fill="none" />
          </svg>
          <svg className='line06'>
            <defs>
              <linearGradient id="grad6" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#818181" />
                <stop offset="100%" stopColor="#313131" />
              </linearGradient>
            </defs>
            <path className='path36' d="M1148 0 L1148 808 Q1148 816, 1156 816 L1272 816 Q1280 816, 1280 824L1280 960" stroke="url(#grad6)" strokeWidth="1" fill="none" />
          </svg>
        </div>

        <div className='step4'>
          <svg className='line-usecase'>
            <defs>
              <linearGradient id="gradH" x2="0%" y2="100%">
                <stop offset="0%" stopColor="rgba(35, 36, 36, .1)" />
                <stop offset="50%" stopColor="rgba(35, 36, 36, .5)" />
                <stop offset="100%" stopColor="rgba(35, 36, 36, .1)" />
              </linearGradient>
              <linearGradient id="gradW">
                <stop offset="0%" stopColor="rgba(35, 36, 36, .1)" />
                <stop offset="50%" stopColor="rgba(35, 36, 36, .3)" />
                <stop offset="100%" stopColor="rgba(35, 36, 36, .1)" />
              </linearGradient>
            </defs>
            <path className='path41' d="M0.5 0 L0.5 960 L0 961" stroke="url(#gradH)" strokeWidth="1" fill="none" />
            <path className='path42' d="M320 0 L320 960 L321 961" stroke="url(#gradH)" strokeWidth="1" fill="none" />
            <path className='path43' d="M640 0 L640 960 L641 961" stroke="url(#gradH)" strokeWidth="1" fill="none" />
            <path className='path44' d="M960 0 L960 960 L961 961" stroke="url(#gradH)" strokeWidth="1" fill="none" />
            <path className='path45' d="M1280 0 L1280 960 L1281 961" stroke="url(#gradH)" strokeWidth="1" fill="none" />
            <path className='path46' d="M0 96 L1280 96 L1281 97" stroke="url(#gradW)" strokeWidth="1" fill="none" />
            <path className='path47' d="M0 288 L1280 288 L1281 289" stroke="url(#gradW)" strokeWidth="1" fill="none" />
            <path className='path48' d="M0 480 L1280 480 L1281 481" stroke="url(#gradW)" strokeWidth="1" fill="none" />
            <path className='path49' d="M0 672 L1280 672 L1281 673" stroke="url(#gradW)" strokeWidth="1" fill="none" />
            <path className='path40' d="M0 864 L1280 864 L1281 865" stroke="url(#gradW)" strokeWidth="1" fill="none" />
          </svg>
        </div>

        <div className='step5'>
          <svg className='line-contact'>
            <path className='path51' d="M0.5 0 L0.5 640 L640 640" stroke="rgba(35, 36, 36, .3)" strokeWidth="1" fill="none" />
            <path className='path52' d="M320 0 L320 640 L321 640" stroke="rgba(35, 36, 36, .3)" strokeWidth="1" fill="none" />
            <path className='path53' d="M640 0 L640 640 L641 640" stroke="rgba(35, 36, 36, .3)" strokeWidth="1" fill="none" />
            <path className='path54' d="M960 0 L960 640 L961 640" stroke="rgba(35, 36, 36, .3)" strokeWidth="1" fill="none" />
            <path className='path55' d="M1280 0 L1280 640 L640 640" stroke="rgba(35, 36, 36, .3)" strokeWidth="1" fill="none" />
          </svg>
        </div>
      </div>

      <div id="scroll-down-animation" className={scrollClass}>
        <span className="mouse">
          <span className="move"></span>
        </span>
        <h2>Scroll down</h2>
      </div>
    
      <div className='section display'></div>

      <div className='linegroup1'>
        <div className='section about-jsl'>
          <div className='container'>
            <div className='cf-wrap'>
              <div className='cf-left'>
                <h2 data-aos="fade-right" data-aos-anchor-placement="bottom-bottom"><strong>제이소프트랩</strong>은<br></br><span>기업 IT 솔루션 제작기업</span><small>입니다</small></h2>
                <img src={cbImages.cb003} className='cb-003'></img>
                <span className='desc'>
                  높은 기술력과 다양한 개발 경험을 바탕으로<br></br>
                  <strong>각종 소프트웨어와 시스템 개발을 전문</strong>으로<br></br>
                  하는 <strong>제이넷시스템즈의 개발 연구소</strong>입니다.<br></br>
                  고객과 소통하며 원하시는 것 이상의<br></br>
                  결과물로 보답하겠습니다.
                </span>
                <img src={cbImages.cb002} className='cb-002'></img>
                <img src={cbImages.cb001} className='cb-001'></img>
                <img src={cbImages.displayLeftBg} className='display-left-bg'></img>
              </div>
              <img src={cbImages.cbCube} className='cb-cube' data-aos="zoom-out" data-aos-anchor-placement="bottom-bottom"></img>
              <div className='cf-right'>
                <img src={cbImages.jnmsEmblem} className='jnms-emblem' data-aos="fade-left" data-aos-anchor-placement="bottom-bottom"></img>
                <img src={cbImages.cb004} className='cb-004'></img>
                <img src={cbImages.cb005} className='cb-005'></img>
                <img src={cbImages.cb006} className='cb-006'></img>
                <img src={cbImages.cb007} className='cb-007'></img>
                <img src={cbImages.cb008} className='cb-008'></img>
                <img src={cbImages.displayRightBg} className='display-right-bg'></img>
              </div>
            </div>
          </div>
        </div>
      
        <div className='section jnms-info'>
          <div className='container'>
            <div className='jnms active'>
              <svg viewBox="0 0 838 273" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className='pathJnms' d="M124.56 8.95998H175.76V188.8C175.76 217.6 168.72 238.72 154.64 252.16C140.773 265.6 118.053 272.32 86.48 272.32C73.4667 272.32 61.6267 270.827 50.96 267.84C40.5067 265.067 31.5467 260.48 24.08 254.08C16.6133 247.893 10.8533 239.893 6.8 230.08C2.74667 220.267 0.720001 208.427 0.720001 194.56V173.12H51.6V193.28C51.6 206.933 54.8 216.427 61.2 221.76C67.8133 227.093 76.56 229.76 87.44 229.76C92.9867 229.76 98 229.12 102.48 227.84C107.173 226.773 111.12 224.747 114.32 221.76C117.52 218.56 119.973 214.293 121.68 208.96C123.6 203.627 124.56 196.8 124.56 188.48V8.95998ZM241.39 8.95998L333.87 173.44V8.95998H383.79V267.52H336.75L244.91 103.36V267.52H193.39V8.95998H241.39ZM517.285 198.72L576.805 8.95998H632.485V267.52H585.765V120L539.045 267.52H495.205L448.805 119.68V267.52H401.765V8.95998H457.445L517.285 198.72ZM781.02 78.08C780.38 65.92 776.22 57.28 768.54 52.16C761.073 47.04 750.727 44.48 737.5 44.48C724.913 44.48 715.207 47.1467 708.38 52.48C701.553 57.6 698.353 66.0267 698.78 77.76C698.993 83.7333 701.34 88.7467 705.82 92.8C710.513 96.8533 716.06 100.267 722.46 103.04C728.86 105.813 735.473 108.053 742.3 109.76C749.34 111.467 755.1 112.96 759.58 114.24C771.1 117.867 781.553 121.92 790.94 126.4C800.54 130.667 808.753 135.893 815.58 142.08C822.407 148.053 827.74 155.2 831.58 163.52C835.42 171.627 837.34 181.44 837.34 192.96C837.34 207.68 834.673 220.16 829.34 230.4C824.22 240.853 817.073 249.173 807.9 255.36C798.727 261.76 788.06 266.24 775.9 268.8C763.74 271.573 750.833 272.747 737.18 272.32C722.887 271.893 709.873 269.867 698.14 266.24C686.62 262.613 676.593 257.173 668.06 249.92C659.74 242.667 653.127 233.6 648.22 222.72C643.527 211.627 640.86 198.507 640.22 183.36H690.78C691.207 198.08 695.687 209.387 704.22 217.28C712.967 224.96 724.38 228.907 738.46 229.12C754.46 229.333 766.513 226.88 774.62 221.76C782.727 216.427 786.46 206.72 785.82 192.64C785.607 186.027 783.9 180.587 780.7 176.32C777.5 172.053 773.233 168.427 767.9 165.44C762.567 162.453 756.38 159.893 749.34 157.76C742.3 155.627 734.94 153.387 727.26 151.04C718.3 148.693 709.02 145.813 699.42 142.4C690.033 138.987 681.5 134.613 673.82 129.28C666.14 123.733 659.74 116.907 654.62 108.8C649.713 100.693 647.26 90.7733 647.26 79.04C647.26 66.24 649.5 54.9333 653.98 45.12C658.673 35.3067 664.967 27.2 672.86 20.8C680.967 14.1867 690.567 9.17333 701.66 5.75999C712.753 2.34666 724.807 0.639996 737.82 0.639996C752.54 0.639996 765.66 2.45332 777.18 6.07998C788.7 9.70665 798.407 14.9333 806.3 21.76C814.407 28.3733 820.593 36.48 824.86 46.08C829.34 55.68 831.793 66.3467 832.22 78.08H781.02Z"/>
              </svg>
            </div>
            <div className='wisight' data-aos="fade-down" data-aos-anchor-placement="top-center">
              <img src={cbImages.wisight}></img>
            </div>
            <div className='input-motion-wrap'>
              <div className='input-motion'>
                <span className='lte'>5G / LTE</span>
                <span className='switch'>Switch</span>
                <span className='ipt'>IPT</span>
                <span className='wireless'>Wireless</span>
                <span className='server'>Server</span>
                <span className='iot'>IOT</span>
              </div>
              <span className='nms' data-aos="zoom-out" data-aos-anchor-placement="bottom-bottom">통합모니터링시스템<small> 입니다.</small></span>
            </div>
            <div className='wi-mockup-wrap' data-aos="fade-left" data-aos-anchor-placement="top-center">
              <img src={cbImages.gsMark} className='gs-mark'></img>
              <span>와이사이트 GS인증 및 조달 3자단가계약 체결<small>[ 물품분류번호 43232902 ]</small></span>
              <img src={cbImages.wisightMockup} className='wi-mockup'></img>
            </div>
          </div>
        </div>
      </div>

      <div className='section features'>
        <div className='container'>
          <div className='sec-title'>Features</div>
          <dl>
            <dt><strong>Basic</strong> <span data-aos="zoom-in" data-aos-offset="400">Speed</span><span data-aos="zoom-in" data-aos-offset="500">Stability</span><span data-aos="zoom-in" data-aos-offset="600">Technology</span></dt>
            <dd>
              기본에 충실했다 라는 말은 많은 뜻을 내포하고 있습니다. 기능 추가보다 우선순위에 두었기에 핵심기술의 고도화에 집중했습니다. 새로운 기술에 대한 과감한 도전과 이미 확증된 구 기술의 적절히 유지하며 시행착오와 많은 테스트를 통해 가장 안정적이며 빠른 모니터링 서비스를 제공하고 있습니다.
            </dd>
          </dl>
          <dl>
            <dt><strong>Customizing</strong> <span data-aos="zoom-in" data-aos-offset="400">Price</span><span data-aos="zoom-in" data-aos-offset="500">Design</span><span data-aos="zoom-in" data-aos-offset="600">Satisfaction</span></dt>
            <dd>
              배보다 배꼽이 더 클 경우가 있습니다. 고객과 끊임없이 소통하며 딱 필요로 하는 기능만을 추가하고 고객의 취향과 편의성까지 고려하여 디자인하고 제작하였습니다. 또한 가장 중요한 가격면에서도 합리적인 선택이 될 것임을 확신합니다.
            </dd>
          </dl>
          <dl>
            <dt><strong>Synergy</strong> <span data-aos="zoom-in" data-aos-offset="400">Know-how</span><span data-aos="zoom-in" data-aos-offset="500">Consulting</span><span data-aos="zoom-in" data-aos-offset="600">Maintenance</span></dt>
            <dd>
              다년간 현장과 IT 분야에서 경험이 많은 영업, 엔지니어, 개발자 등이 모여 필요에 의해 시작된 프로젝트 입니다. 컨설팅부터 구축, 관리까지 전문적인 지식과 노하우로 사업 전반적으로 필요로 하는 서비스를 함께 생각하며 성장하는 파트너가 되겠습니다.
            </dd>
          </dl>
        </div>
      </div>

      <div className='section services'>
        <div className='container'>
          <div className='sec-title'>Line up</div>
          <div className='contents-wrap'>
            <div className='item inms'>
              <div className='m-title'>INMS</div>
              <strong>IPT NMS Service</strong>
              <ul>
                <li>Call Server + IP Phone 정보 수집</li>
                <li>네트워크 장비 상태 체크</li>
                <li>통화목록 ( 수발신, 통화 정보 등 )</li>
              </ul>
            </div>
            <div className='item wnms'>
              <div className='m-title'>WNMS</div>
              <strong>Wireless NMS Service</strong>
              <ul>
                <li>AP Controller + AP + Wips 정보 수집</li>
                <li>네트워크 장비 상태 체크</li>
                <li>스테이션 ( AP 상세정보 제공 )</li>
              </ul>
            </div>
            <div className='item snms'>
              <div className='m-title'>SNMS</div>
              <strong>Switch / Server NMS Service</strong>
              <ul>
                <li>Switch, Server 정보 수집</li>
                <li>부가장비 상태 체크</li>
              </ul>
            </div>
            <div className='item common'><span className='plus'>+</span></div>
            <div className='item common'>
              <ul>
                <li>모든 장비 정보 관리 및 상태 체크</li>
                <li>장비 및 사용자 로그 이력</li>
                <li>장비별 기간별 통계 및 보고서</li>
                <li>실시간 장애 알림 ( 이메일, SMS 등 )</li>
              </ul>
            </div>
            <div className='item common'>
              <ul>
                <li>라이센스 관리</li>
                <li>중요 데이터 백업 및 복구</li>
                <li>IP 접속제한 관리</li>
              </ul>
            </div>
            <div className='item option'>
              <div className='title'>JBoard</div>
              <span>모니터링 운영시 고객과의 소통을 지원하는 민원관리 <strong>게시판 프로그램</strong></span>
            </div>
            <div className='item option'>
              <div className='title'>JChart</div>
              <span>원하는 장비 및 자원의 정보를 차트를 통해 모아서 보여주는 <strong>단일 모니터링 페이지</strong></span>
            </div>
            <div className='item option'>
              <div className='title'>JLine</div>
              <span>사용자가 관리하는 장비 및 케이블 정보를 관리하는 <strong>선번장 프로그램</strong></span>
            </div>
          </div>
        </div>
      </div>

      <div className={`section demo bg-${checkList[btnActive].classname}`}>
        <div className='left-bg'></div>
        <div className='container'>
          {checkList.map((item, idx) => (
            <div key={idx} className={`card ${item.classname} ${idx === btnActive ? 'active' : ''}`}>
              <button id={idx} type='radio' onClick={() => toggleActive(idx)} className='default-contents'>
                <label htmlFor={idx} className='title' data-aos="fade-right">{item.title}<span>{item.titleSub}</span></label>
              </button>
              <div className='active-contents'>
                <div className='title' data-aos="fade-right">{item.title}</div>
                <div className='btnDemo'>
                  <span>{item.content}</span>
                  {/* <a href={item.link} target='_blank'>GO</a> */}
                </div>
                <img src={item.img} alt='데모 지도' />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='section usecase'>
        <div className='container'>
          <div className='sec-title'>Use case</div>
          <div className='case-wrap'>
            <div onClick={()=>handleModal(18)} className={checkActive ? 'case-item active inms' :'case-item inms'}>
              <span className='cate'>NETWORK NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>대구시청</div>
            </div>
            <div onClick={()=>handleModal(17)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>전남도청</div>
            </div>
            <div onClick={()=>handleModal(16)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>춘천시청</div>
            </div>
            <div onClick={()=>handleModal(15)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>안산시청</div>
            </div>
            <div onClick={()=>handleModal(14)} className='case-item snms' onMouseOver={handleOver}>
              <span className='cate'>NETWORK NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>헤이그라운드</div>
            </div>
            <div onClick={()=>handleModal(13)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>전북도청</div>
            </div>
            <div onClick={()=>handleModal(12)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>안양시청</div>
            </div>
            <div onClick={()=>handleModal(11)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>과천시청</div>
            </div>
            <div onClick={()=>handleModal(10)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>의정부시청</div>
            </div>
            <div onClick={()=>handleModal(9)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>양구군청</div>
            </div>
            <div onClick={()=>handleModal(8)} className='case-item inms' onMouseOver={handleOver}>
              <span className='cate'>IPT NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>경기북부교육청</div>
            </div>
            <div onClick={()=>handleModal(7)} className='case-item inms' onMouseOver={handleOver}>
              <span className='cate'>IPT NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>부천시청</div>
            </div>
            <div onClick={()=>handleModal(6)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>양주시청</div>
            </div>
            <div onClick={()=>handleModal(5)} className='case-item inms' onMouseOver={handleOver}>
              <span className='cate'>IPT NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>한국외식업중앙회</div>
            </div>
            <div onClick={()=>handleModal(4)} className='case-item snms' onMouseOver={handleOver}>
              <span className='cate'>NETWORK NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>울산문수축구경기장</div>
            </div>
            <div onClick={()=>handleModal(3)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>김포시청</div>
            </div>
            <div onClick={()=>handleModal(2)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>경복대학교</div>
            </div>
            <div onClick={()=>handleModal(1)} className='case-item wnms' onMouseOver={handleOver}>
              <span className='cate'>WIFI NMS</span>
              <a className='btnLink'>GO</a>
              <div className='title'>수원시청</div>
            </div>
          </div>
        </div>
      </div>

      <div className='section contactus'>
        <div className='container'>
          <div className='mail sales' data-aos="fade-up">
            <span id='text1' ref={textRef1}><strong>sales</strong>@jnetsystems.com</span>
            <a href="mailto:sales@jnetsystems.com" className='btnMail' title='메일보내기'><MailOutline/></a>
            <a id='button1' onClick={() => copyClipboard(textRef1, '메일 주소가 복사되었습니다.')} className='btnCopy' title='주소복사'><ClipboardOutline/></a>
          </div>
          <div className='mail dev' data-aos="fade-up">
            <span id='text2' ref={textRef2}><strong>dev</strong>@jsoftlab.co.kr</span>
            <a href="mailto:dev@jsoftlab.co.kr.com" className='btnMail' title='메일보내기'><MailOutline/></a>
            <a id='button2' onClick={() => copyClipboard(textRef2, '메일 주소가 복사되었습니다.')} className='btnCopy' title='주소복사'><ClipboardOutline/></a>
          </div>
          <img data-aos="zoom-out-down" data-aos-anchor-placement="bottom-bottom" src={wiMockupContact}></img>
        </div>
      </div>

      {modalDatas.map((item, idx) => {
        return (
          <div key={idx} style={{ display: item.idx ==  modalCheck ? 'flex' : 'none'}} >
            <div className='caseModal-wrap' style={{display : modalClose == 'none' ? 'none' : 'flex'}} > {/* flex 로 변경 */}
              <div className='caseModal'>   
                <div className='modalHeader'>
                  <div className='caseTitle'>{item.title}</div>
                    <a onClick={handleEsc} ><CloseSharp /></a>
                </div>
                <div className='image-box'>
                  <img src={item.img}/>
                </div>
                <div className='caseDesc'>
                  <ul>
                    <li>{item.gubun}</li>
                    <li>{item.significant}</li>
                  </ul>
                </div>
              </div>
              <div className='modalBg' onClick={handleEsc}></div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
